import script from "./EditCampaign.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditCampaign.vue?vue&type=script&setup=true&lang=ts"

import "./EditCampaign.vue?vue&type=style&index=0&id=b48fa242&lang=css"

const __exports__ = script;

export default __exports__